module.exports = __webpack_public_path__ + "img/1234567897.23711cae.png";